import React from 'react'

import Container from '../Container'

const Geofences = ({ children }) => (
  <>
    <Container as="main">
      {children}
    </Container>
  </>
)

export default Geofences
